export enum PropertyTypeEnum {
  APARTMENT = "APARTMENT",
  SINGLE_FAMILY_HOUSE = "SINGLE_FAMILY_HOUSE",
  TOWNHOUSE = "TOWNHOUSE",
  SEMI_DETACHED_HOUSE = "SEMI_DETACHED_HOUSE",
  TWO_FAMILY_HOUSE = "TWO_FAMILY_HOUSE",
  APARTMENT_BUILDING = "APARTMENT_BUILDING",
  CREATIVE_LIVING = "CREATIVE_LIVING",
  LAND_PLOT = "LAND_PLOT",
}

export enum ApplicationTypeEnum {
  BUY_WITH_SAVINGS = "BUY_WITH_SAVINGS",
  BUILD_HOUSE = "BUILD_HOUSE",
  REFINANCING = "REFINANCING",
  MODERNIZATION = "MODERNIZATION",
  RAISE_CAPITAL = "RAISE_CAPITAL",
  FINANCE_ADDITIONAL_COSTS = "FINANCE_ADDITIONAL_COSTS",
}

export enum CostTypeEnum {
  ADDITIONAL_CONSTRUCTION = "ADDITIONAL_CONSTRUCTION",
  CONSTRUCTION = "CONSTRUCTION",
  DEVELOPMENT = "DEVELOPMENT",
  NOTARY_FEE = "NOTARY_FEE",
  OTHER = "OTHER",
  OUTDOOR_FACILITIES = "OUTDOOR_FACILITIES",
  PROPERTY_TRANSFER_TAX = "PROPERTY_TRANSFER_TAX",
  PURCHASE_PRICE = "PURCHASE_PRICE",
  REAL_ESTATE_AGENT_FEE = "REAL_ESTATE_AGENT_FEE",
}

export enum PreferenceTypeEnum {
  FIXED_INTEREST_RATE = "FIXED_INTEREST_RATE",
  REPAYMENT_RATE = "REPAYMENT_RATE",
  INSTALLMENT = "INSTALLMENT",
  LOAN_TERM = "LOAN_TERM",
  SPECIAL_REPAYMENT = "SPECIAL_REPAYMENT",
  INTEREST_FREE_PERIOD = "INTEREST_FREE_PERIOD",
}

export enum ValueTypeEnum {
  ABSOLUTE = "ABSOLUTE",
  PERCENTAGE = "PERCENTAGE",
  MONTH = "MONTH",
  YEAR = "YEAR",
  BOOLEAN = "BOOLEAN",
}
